module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_ohiolink_3_b431279.png";